import type { ReactNode } from 'react'

import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

type LegalPageLayoutProps = {
  title: string
  lastUpdated: string
  children: ReactNode
}

export function LegalPageLayout({ title, lastUpdated, children }: LegalPageLayoutProps) {
  return (
    <>
      <Head title={title} />
      <div className="flex min-h-screen flex-col">
        <main className="flex-1">
          <Container className="mb-12">
            <Navbar />
            <h1 className="mt-12 mb-4 text-3xl">{title}</h1>
            <p className="text-muted-foreground mb-8 text-sm">Last updated: {lastUpdated}</p>
            {children}
          </Container>
        </main>
        <Footer />
      </div>
    </>
  )
}
